import Icon from '@/components/ui/AppIcon';

export default function MissionVision() {
  const values = [
    {
      id: 'mission',
      icon: 'RocketLaunchIcon',
      title: 'Our Mission',
      description:
        'To empower businesses of all sizes with cutting-edge digital solutions that drive growth, engagement, and lasting success in the digital age.',
    },
    {
      id: 'vision',
      icon: 'EyeIcon',
      title: 'Our Vision',
      description:
        'To be the most trusted digital partner for businesses worldwide, known for innovation, excellence, and transformative results that exceed expectations.',
    },
    {
      id: 'values',
      icon: 'HeartIcon',
      title: 'Our Values',
      description:
        'Integrity, creativity, and client success are at the core of everything we do. We believe in building long-term partnerships based on trust and measurable results.',
    },
  ]

  return (
    <section className="py-20 md:py-32 bg-zinc-950 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, idx) => (
            <div
              key={value.id}
              className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 hover:border-amber-500/30 transition-all glow-hover reveal"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="w-16 h-16 mb-6 flex items-center justify-center text-amber-500 bg-amber-500/10 rounded-xl">
                <Icon name={value.icon as any} size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white">{value.title}</h3>
              <p className="text-zinc-400 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}